import { createContext, useContext } from 'react';
const NamespacesContext = /*#__PURE__*/createContext({
  context: {},
  text: {},
  system: {}
});
export const NamespacesProvider = NamespacesContext.Provider;
export function useNamespaces() {
  return useContext(NamespacesContext);
}